import ModalComponent from '@components/common/Modal';
import OrderManagerApi from 'apis/api/OrderManager';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, message, Tooltip } from 'antd';
import { FaUpload } from 'react-icons/fa';
import { IoCloseCircleSharp } from 'react-icons/io5';
import { IconButton } from 'rsuite';
import ModalViewImages from './ModalViewImages';
import Helpers from 'helpers/Helpers';

interface IOMConfig {
  isOpen: boolean;
  base64?: string;
  callBackClose?: () => any;
  callBackRefresh?: () => any;
  callBackCreate?: (data: any) => any;
  listHinh?: any;
  data?: any;
  status?: any;
  //   dataAccountant: ISelectOption[];
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
}

// usage

export default function ModalUpdateImages(props: IOMConfig) {
  // console.log('test', props.data.data.statusVNText);

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const inputRef = useRef<any>();
  const [listHinhNew, setListHinhNew] = useState<any[]>([]);
  const [listHinh, setListHinh] = useState<any[]>(props.listHinh);
  const [valueListHinh, setValueListHinh] = useState<any[]>();
  const [valueListHinhNew, setValueListHinhNew] = useState<any[]>();
  const [images, setImages] = useState<any>(false);
  const [images1, setImages1] = useState<any>();
  const handleChangeValueHinh = (e, index) => {
    e.preventDefault();
    const value = e.target.value;
    setValueListHinh({
      ...valueListHinh,
      [index]: value
    });
  };
  const handleChangeValueHinhNew = (e, index) => {
    e.preventDefault();
    const value = e.target.value;
    setValueListHinhNew({
      ...valueListHinhNew,
      [index]: value
    });
  };

  // console.log(previewImage.split('data:image/png;base64,').join(''));
  const handleFormSubmit = async (evt: any) => {
    const value = [];
    const valueHinh = [];
    for (let i = 0; i < listHinh.length; i++) {
      valueHinh.push({
        ...listHinh[i],
        id: listHinh[i].uid,
        // base64: prod.thumbUrl?.replace(/^data:image\/[a-z]+;base64,/, ''),
        base64: '',
        comment: valueListHinh ? valueListHinh[`${i}`] || listHinh[i].name : listHinh[i].name,
        name: valueListHinh ? valueListHinh[`${i}`] || listHinh[i].name : listHinh[i].name,
        context: props.data?.status
      });
    }

    for (let i = 0; i < listHinhNew.length; i++) {
      await getBase64(listHinhNew[i]) // `file` your img file
        .then((res: string) =>
          value.push({
            ...listHinhNew[i],
            id: 0,
            // base64: prod.thumbUrl?.replace(/^data:image\/[a-z]+;base64,/, ''),
            base64: res.replace(/^data:image\/[a-z]+;base64,/, ''),
            comment: valueListHinhNew ? valueListHinhNew[`${i}`] : '',
            context: props.data?.status
          })
        ) // `res` base64 of img file
        .catch(err => console.log(err));
    }

    const dataBody = {
      maDonHang: props.data?.data?.maDonHang,
      listHinh: valueHinh,
      listHinhNew: value
    };
    // console.log({ dataBody });

    try {
      if (dataBody) {
        // console.log('dataBody', dataBody, value);
        // setConfirmLoading(true);
        await OrderManagerApi.UploadImageOrder(dataBody).then(res => {
          if (!res.data.error) {
            message.success(t('StockManagement.ProductMix.Create.Success'));
            // form && form.setFieldsValue(initialsValue);
            props.callBackRefresh();
            props.callBackClose();
          } else {
            if (res.data.messageCode == 'CODE_EXIST') message.error(t('System.ExistData'));
            else message.error(t('StockManagement.ProductMix.Create.Error'));
          }
          // setConfirmLoading(false);
        });
      }
    } catch (error) {
      console.log(error);
      // setConfirmLoading(false);
      message.error(t('StockManagement.ProductMix.Create.Error'));
    }
  };
  const onChooseFile = () => {
    inputRef.current.click();
  };
  // console.log({ listHinhNew });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files.length === 1) {
      const isJpgOrPng = e.target.files[0].type === 'image/jpeg' || e.target.files[0].type === 'image/png';
      if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
      } else {
        if (e.target.files && e.target.files.length > 0) {
          setListHinhNew([...listHinhNew, e.target.files[0]]);
        }
      }
    } else {
      for (let i = 0; i < e.target.files.length; i++) {
        const isJpgOrPng = e.target.files[i].type === 'image/jpeg' || e.target.files[i].type === 'image/png';
        if (!isJpgOrPng) {
          message.error('You can only upload JPG/PNG file!');
        } else {
          if (e.target.files && e.target.files.length > i) {
            setListHinhNew([...listHinhNew, ...e.target.files]);
          }
        }
      }
    }
  };

  const handleDeleteImageListHinhNew = e => {
    listHinhNew.splice(listHinhNew.indexOf(e), 1);
    setListHinhNew([...listHinhNew]);
  };
  const handleDeleteImageListHinh = e => {
    listHinh.splice(listHinh.indexOf(e), 1);
    setListHinh([...listHinh]);
  };

  const handleDownloadImage = async url => {
    try {
      // xử lý lại lưu ảnh theo draw canvas dùng id img tag để lấy ảnh cần lưu
    } catch (error) {
      console.log('err downlaod', error);
      message.error('Trình duyệt không hỗ trợ tải ảnh trực tiếp về thiết bị!');
    }
  };

  return (
    <ModalComponent
      modalTitle={t('Administrator.UploadImage.Title')}
      //   modalType="create"
      modalType="confirm"
      modalSize="medium"
      visible={props.isOpen}
      onOk={handleFormSubmit}
      hiddenFooter={props.data.data.statusVNText === 'Hoàn tất' ? true : false}
      okText="Lưu"
      okStyle="primary"
      //   confirmLoading={confirmLoading}
      onCancel={props.callBackClose}
    >
      {images && (
        <ModalViewImages
          callBackClose={() => setImages(false)}
          isOpen={images}
          images1={images1}
          callBackRefresh={() => console.log('call refresh')}
        />
      )}

      <div className="flex flex-wrap overflow-y-auto max-h-[80vh]">
        <input ref={inputRef} type="file" multiple onChange={handleFileChange} style={{ display: 'none' }} />
        <div className="flex flex-wrap">
          {listHinh?.map((e, index) => {
            return (
              <div className="border ml-4 mb-4 rounded relative" key={e.uid}>
                {props.data.data.statusVNText !== 'Hoàn tất' ? (
                  <div className="absolute z-10 right-1 top-1" onClick={() => handleDeleteImageListHinh(e)}>
                    <Tooltip
                      trigger={['hover']}
                      // mouseEnterDelay={delayHoverTooltip}
                      mouseLeaveDelay={0.1}
                      placement="bottom"
                    >
                      <IconButton>
                        <IoCloseCircleSharp color="red" size={22} />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  ''
                )}

                <div
                  className="w-[300px]  flex items-center justify-items-center hover cursor-pointer "
                  onClick={() => {
                    setImages1(e);
                    setImages(true);
                  }}
                >
                  {/* <ModalImage
                  className="w-[300px] flex items-center justify-items-center h-[250px] object-contain"
                  small={e.url}
                  large={e.url}
                  hideDownload
                /> */}
                  <img className="w-full h-[250px] object-contain" src={e.url} alt="" />
                </div>

                <div className="p-2 ">
                  {props.data.data.statusVNText === 'Hoàn tất' || props.data.data.statusVNText !== 'Hoàn tất' ? (
                    <div className="">
                      <div className="float-left px-1 rounded hover:bg-blue-400">
                        {/* <button className="text-blue-500 hover:text-white" onClick={() => handleDownloadImage(e.url)}>
                          Tải ảnh về
                        </button> */}
                      </div>
                      <div className="float-right rounded px-1 hover:bg-blue-400 hover:text-white">
                        <a
                          className="hover:text-white text-blue-500"
                          href={e.url}
                          target="_blank"
                          rel="noreferrer"
                          // download="https://svomdev.adsun.vn/OrderImages/20240611/240608004/fdfef8bb-c5da-480a-b896-51b451a4aea1.png"
                        >
                          Mở tab mới
                        </a>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <Input
                    className="mt-1"
                    // value={valueListHinh ? valueListHinh[`${index}`] : ''}
                    disabled={props.data.data.statusVNText === 'Hoàn tất' ? true : false}
                    onChange={e => handleChangeValueHinh(e, index)}
                    style={{ width: '100%' }}
                    placeholder={t('Input.noteImages')}
                    defaultValue={e.name}
                  />
                </div>
              </div>
            );
          })}
          {listHinhNew && listHinhNew.length > 0 ? (
            listHinhNew?.map((e, index) => {
              return (
                <div className="border  ml-4 mb-4 rounded relative" key={e.uid}>
                  {props.data.data.statusVNText !== 'Hoàn tất' ? (
                    <div className="absolute z-10 right-1 top-1" onClick={() => handleDeleteImageListHinhNew(e)}>
                      <Tooltip
                        trigger={['hover']}
                        // mouseEnterDelay={delayHoverTooltip}
                        mouseLeaveDelay={0.1}
                        placement="bottom"
                      >
                        <IconButton>
                          <IoCloseCircleSharp color="red" size={22} />
                        </IconButton>
                      </Tooltip>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="w-[300px]  flex items-center justify-items-center ">
                    <img className="w-full h-[250px] object-contain 	" src={URL.createObjectURL(e)} alt="" />
                  </div>

                  <div className="p-2">
                    <Input
                      // value={valueListHinhNew ? valueListHinhNew[`${index}`] : ''}
                      disabled={props.data.data.statusVNText === 'Hoàn tất' ? true : false}
                      onChange={e => handleChangeValueHinhNew(e, index)}
                      style={{ width: '100%' }}
                      placeholder={t('Input.noteImages')}
                    />
                  </div>
                </div>
              );
            })
          ) : (listHinh && listHinh.length > 0) || (listHinhNew && listHinhNew.length > 0) ? (
            ''
          ) : (
            <div className=" relative left-[300px]">
              <div className="flex flex-col items-center justify-center mt-10 opacity-0	">
                <img
                  width={300}
                  height={300}
                  src="https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg"
                  alt=""
                />
                <p className="font-bold text-lg text-gray-600">Không có hình ảnh !!!</p>
              </div>
            </div>
          )}
          {props.data.data.statusVNText === 'Hoàn tất' ? (
            ''
          ) : (
            <div className="w-[300px] ml-4 mb-4 rounded relative cursor-pointer h-[250px]">
              <div className="absolute top-[30%] left-[30%] ">
                <FaUpload
                  size={`${(listHinh && listHinh.length > 0) || (listHinhNew && listHinhNew.length > 0) ? 56 : 90}`}
                  color="#1890ff"
                  onClick={() => onChooseFile()}
                />
                {/* "-ml-5 font-bold" */}
                <span
                  className={`${
                    (listHinh && listHinh.length > 0) || (listHinhNew && listHinhNew.length > 0)
                      ? '-ml-5 font-bold'
                      : '-ml-5 font-bold text-xl'
                  }`}
                >
                  Thêm hình ảnh
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </ModalComponent>
  );
}
